/** Domínio em produção em que o item PRÊMIOS aparece no menu lateral. */
export const DOMINIO_EXIBE_MENU_PREMIOS = 'dqentregas.com.br'

const DOMINIOS_EXIBE_MENU_PREMIOS = new Set([
	DOMINIO_EXIBE_MENU_PREMIOS,
	'localhost',
])

function normalizarDominio(dominio) {
	return String(dominio || '')
		.trim()
		.toLowerCase()
		.replace(/^www\./, '')
		.split(':')[0]
}

/** App rodando em ambiente de desenvolvimento local (mesmo critério de API.jsx). */
export function ehAmbienteLocalhost() {
	if (typeof window === 'undefined') return false
	const host = window.location.hostname.toLowerCase()
	return host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.')
}

export function exibeMenuPremios(dominio) {
	const d = normalizarDominio(dominio)
	if (DOMINIOS_EXIBE_MENU_PREMIOS.has(d)) return true
	return ehAmbienteLocalhost()
}

/** Índices usados em `MenuLateral ativo={...}` conforme presença dos itens PRÊMIOS e Chamar Guincho. */
export function indiceMenuRelatorios(dominio) {
	return exibeMenuPremios(dominio) ? 6 : 4
}

export function indiceMenuDadosAdicionais(dominio) {
	return exibeMenuPremios(dominio) ? 7 : 5
}

export function indiceMenuConfiguracoes(dominio) {
	return exibeMenuPremios(dominio) ? 8 : 6
}

export function indiceMenuPoliticaPrivacidade(dominio) {
	return exibeMenuPremios(dominio) ? 9 : 7
}

/** Índice do item "Registro jornada (KM)" após Central de Ajuda opcional. */
export function indiceMenuRegistroKm(dominio, temCentralAjuda) {
	let n = exibeMenuPremios(dominio) ? 10 : 8
	if (temCentralAjuda) n++
	return n
}
